import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { Button, WContainer, WImage } from '@next-nx/shared-ui/atoms'
import styles from './CopertinaBox.module.sass'


interface Props {
  item: MenuItemType | undefined
  imagePos: 'left' | 'right'
  className?: string
  editMode?: boolean
}

const CopertinaBox = (props: Props) => {

  const { 
    item = undefined,
    imagePos = 'right',
    className = '',
    editMode = false,
  } = props

  return item ? (
    <div className={`${styles.root} ${styles[`root--image-${imagePos}`]} ${className}`}>
      <WContainer>
        <div className={styles.layout}>
          <div className={styles.content}>
            {!!item.name && (
              editMode || (typeof item.name !== 'string')
              ? <div className={styles.title}>{item.name}</div>
              : <p className={styles.title}>{item.name}</p>
            )}
            {!!item.description && (
              editMode || (typeof item.description !== 'string')
              ? <div className={styles.description}>{item.description}</div>
              : <div className={styles.description} dangerouslySetInnerHTML={{ __html: item.description}} />
            )}
            {!!item.ctaLabel && !!item.url && (
              <div className={styles.ctaBox}>
                <Button label={item.ctaLabel} href={item.url} newPage={item.blank} />
              </div>
            )}
          </div>
          <div className={`${styles.imageBox} ${item.imageMobile ? styles['imageBox--desktop'] : ''}`}>
            <WImage 
              src={item.image}
              alt={item.name}
              title={item.name}
              maxWidth={960}
              maxHeight={432}
              layout="fill"
              objectFit="cover"
            />
          </div>
        </div>
      </WContainer>
    </div>
  ) : <></>
}

export default CopertinaBox
